<template>
  <div :class="[
    'accordion-content',
    'single-filter-value',
    { 'disabled': singleFilter.count == 0 && !singleFilter.value.includes('price_USD_') && !isSelected },
    { 'selected': isSelected },
    { 'with-icon': ['Frame Color', 'Shape', 'Type', 'Lens Color'].includes(singleFilter.attributeLabel) },
    { 'color-filter': ['Frame Color', 'Lens Color'].includes(singleFilter.attributeLabel) },
    { 'lens-treatment': 'Lens Treatment' === singleFilter.attributeLabel }

  ]" @click="toggleFilter(singleFilter)">
    <span v-if="['Frame Color', 'Shape', 'Type', 'Lens Color'].includes(singleFilter.attributeLabel)" :class="[
      ['Frame Color', 'Lens Color'].includes(singleFilter.attributeLabel)
        ? `iconglasses-icons-${formatClass(singleFilter.label)}`
        : `glasses-rp-${formatClass(singleFilter.label)}`
    ]">
    </span>
    <div class="filter-value-container">
      <p class="filter-value-title">{{ formattedLabel }}</p>
      <p class="filter-value-description" v-if="'Lens Treatment' === singleFilter.attributeLabel">{{
        singleFilter.extendedData.field3 }}</p>
    </div>
    <div v-if="isSelected" class="delete-filter-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_774_9337)">
          <path
            d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM8 14.6667C4.324 14.6667 1.33333 11.676 1.33333 8C1.33333 4.324 4.324 1.33333 8 1.33333C11.676 1.33333 14.6667 4.324 14.6667 8C14.6667 11.676 11.676 14.6667 8 14.6667Z"
            fill="white" />
          <path
            d="M10.1953 4.862L8 7.05733L5.80467 4.862L4.862 5.80467L7.05733 8L4.862 10.1953L5.80467 11.138L8 8.94267L10.1953 11.138L11.138 10.1953L8.94267 8L11.138 5.80467L10.1953 4.862Z"
            fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_774_9337">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  </div>
</template>

<script>
import Bean from "./Bean.ts";
export default {
  ...Bean,
};
</script>
<style lang="scss">
@import "./Bean.scss";
</style>